import React from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import copyToClipboard from 'copy-to-clipboard'

import IconChevronRight from 'client/icons/ChevronRight'
import IconCopy from 'client/icons/Copy'

import { addError } from 'src/utils/clientErrorReporter'
import { usePage } from 'src/hooks/usePage'
import { useKafkaEvent } from 'src/hooks/useKafkaEvent'
import { SECTIONS } from 'src/hooks/useKafkaEvent/constants'

import styles from './styles.module.css'
import { displayAlertAction } from 'src/comps/AlertMessage/actions'

interface ShareCopyProps {
  propertyId: number
}

const ShareCopy = ({ propertyId }: ShareCopyProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const { pageId } = usePage()
  const { sendEvent } = useKafkaEvent({ page: pageId, eventName: 'click' })

  function handleClick() {
    const currentUrl = new URL(window.location.href)
    if (currentUrl.pathname === '/hotel/[country]/[slug]') {
      addError(new Error('[Copy Link] Bad URL'))
    }

    sendEvent(
      { section: SECTIONS.SHARE_MODAL_OPTION },
      {
        option: 'copy',
        propertyId,
      }
    )

    copyToClipboard(window.location.href)

    dispatch(
      displayAlertAction({
        description: intl.formatMessage({
          id: 'global.copied',
        }),
        severity: 'success',
      })
    )
  }

  return (
    <button type="button" data-testid="share-copy" className={styles.button} onClick={handleClick}>
      <IconCopy />
      <p>
        {intl.formatMessage({
          id: 'global.copy-link',
        })}
      </p>
      <IconChevronRight />
    </button>
  )
}

export default ShareCopy
